var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Row, Col, Accordion, Button } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { Controller, } from "react-hook-form";
import { RecekTextField } from "./inputs";
export var LegalPersonAlternativeNameFields = function (_a) {
    var control = _a.control, errors = _a.errors, alternativeNameFields = _a.alternativeNameFields, onAddAlternativeName = _a.onAddAlternativeName, onRemoveAlternativeName = _a.onRemoveAlternativeName;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Accordion, { label: formatMessage({
            id: "ui-br-agency.natural-person.accordions.label.alternativeNames",
        }), separator: false },
        alternativeNameFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
            React.createElement(Col, { xs: 10 },
                React.createElement(Controller, { control: control, name: "legalAlternativeNames.".concat(index, ".name"), render: function (_a) {
                        var _b, _c, _d;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.legal-person.legalAlternativeNames.field.label", error: (_d = (_c = (_b = errors.legalAlternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.message, required: true })));
                    } })),
            React.createElement(Col, { xs: 2 },
                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return onRemoveAlternativeName(index); }, style: { marginTop: "1.5rem" } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.remove" }))))); }),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { buttonStyle: "default", onClick: onAddAlternativeName },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.natural-person.button.addAlternativeName" }))))));
};
